import { render, staticRenderFns } from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=template&id=1fd6b9d8"
import script from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=style&index=0&id=1fd6b9d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports